import type { TypedDocumentNode } from '@apollo/client';
import { gql, useMutation } from '@apollo/client';

// eslint-disable-next-line import-x/named
import type { destroyAccountInput } from '#src/__generated__/globalTypes.ts';

import type {
  DestroyUserAccountMutation,
  DestroyUserAccountMutationVariables,
} from './__generated__/useDestroyAccount.graphql.ts';

const DESTROY_USER_ACCOUNT_MUTATION = gql`
  mutation DestroyUserAccountMutation($input: destroyAccountInput!) {
    destroyAccount(input: $input) {
      currentUser {
        slug
      }

      errors {
        path
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  DestroyUserAccountMutation,
  DestroyUserAccountMutationVariables
>;

export const useDestroyAccount = () => {
  const [mutate] = useMutation(DESTROY_USER_ACCOUNT_MUTATION);

  return async (input: destroyAccountInput) => mutate({ variables: { input } });
};
